import { Modal } from 'react-bootstrap-5';
import EditModal from './shared_edit_modal';
import React, { useState } from 'react';
import { BrokerError, BrokerPanel, deleteRecord, modifyRecordArray, getChildCompanyUrlSuffix } from './shared';
import PropTypes from 'prop-types';
import Button from 'shared/button';

export default function Organizations(props) {
  const [organizations, setOrganizations] = useState(props.organizations);
  const [modalObject, setModalObject] = useState({ isOpen: false, id: '' });
  const [error, setError] = useState('');

  const openModal = id => setModalObject({ isOpen: true, id });
  const closeModal = () => setModalObject({ isOpen: false, id: '' });
  const organizationToEdit = modalObject.id === '' ? null : organizations.find(cert => cert.id === modalObject.id);

  const handleFormSubmit = (newOrganization) => {
    modifyRecordArray(newOrganization, setOrganizations, organizations, 'title', modalObject, closeModal);
  };

  const deleteOrganization = ({ title, id }) => {
    const urlSuffix = getChildCompanyUrlSuffix();
    deleteRecord(id, title, '/broker_organizations', 'Organization', setOrganizations, setError, urlSuffix);
  };

  const editFields = [{ name: 'title', isRequired: true, value: organizationToEdit?.title }];

  const addNewOrganization = () => openModal('');

  return (
    <React.Fragment>
      <Modal
        centered
        show={modalObject.isOpen}
        onHide={closeModal}
      >
        <EditModal
          databaseName="broker_organization"
          editFields={editFields}
          id={modalObject.id}
          initials={organizationToEdit?.initials}
          key={`${modalObject.isOpen}-${modalObject.id}`}
          objectName="Organization"
          title={organizationToEdit?.title}
          onCloseModal={closeModal}
          onSuccessfulFormSubmit={handleFormSubmit}
        />
      </Modal>
      <div className="d-flex justify-content-between mb-3 mt-5 align-items-center top-buffer-xl">
        <h5 className="m-0">Organizations</h5>
        <Button.Primary type="button" onClick={addNewOrganization}>Add Organization</Button.Primary>
      </div>

      <BrokerError error={error}/>
      <BrokerPanel
        cantModifyMessage="Corporate Organization"
        deleteRecord={deleteOrganization}
        firstColumnIdentifier="title"
        openModal={openModal}
        recordName="Organization"
        records={organizations}
        secondColumnIdentifier=""
        onClick={addNewOrganization}
      />
    </React.Fragment>
  );
}

export const organizationsPropTypes = {
  organizations: PropTypes.arrayOf(PropTypes.shape({
    canModify: PropTypes.bool.isRequired,
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired
  })).isRequired,
};

Organizations.propTypes = {
  ...organizationsPropTypes
};
